import classNames from "classnames";
import { Counter } from "PFApp/components/counter";
import { Button } from "PFComponents/button";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { WorkOpportunitiesTab } from "../../../constants";
import { useMarketplaceContext } from "../../../contexts/marketplace_context";
import { useMarketplaceCounters } from "../../../hooks/use_marketplace_counters";
import { useWorkOpportunitiesTab } from "../../hooks/use_work_opportunities_tab";
import css from "./counters.module.scss";

type CountersData = {
  title: string;
  tab: WorkOpportunitiesTab;
  counter: number | undefined;
  displayRightSeparator: boolean;
};

export const Counters = (): JSX.Element => {
  const { t } = useTranslation("marketplace", { keyPrefix: "workOpportunities" });
  const history = useHistory();
  const { modal, setSelectedRole } = useMarketplaceContext();
  const currentTab = useWorkOpportunitiesTab();

  const { matchingActivitiesCount, interestedActivitiesCount, savedActivitiesCount, sharedActivitiesCount } =
    useMarketplaceCounters();

  const handleTabChange = (newTab: WorkOpportunitiesTab) => {
    history.push(`/marketplace/work_opportunities/${newTab}`);
    setSelectedRole(null, null);
  };

  const handlePreferencesClick = () => {
    modal.setType("editPreferences");
  };

  const countersData: CountersData[] = useMemo(
    () => [
      {
        title: t("matchingRoles"),
        tab: WorkOpportunitiesTab.MatchingRoles,
        counter: matchingActivitiesCount,
        displayRightSeparator: true
      },
      {
        title: t("interested"),
        tab: WorkOpportunitiesTab.Interested,
        counter: interestedActivitiesCount,
        displayRightSeparator: false
      },
      {
        title: t("savedRoles"),
        tab: WorkOpportunitiesTab.SavedRoles,
        counter: savedActivitiesCount,
        displayRightSeparator: false
      },
      {
        title: t("sharedWithMe"),
        tab: WorkOpportunitiesTab.SharedWithMe,
        counter: sharedActivitiesCount,
        displayRightSeparator: false
      }
    ],
    [t, matchingActivitiesCount, interestedActivitiesCount, savedActivitiesCount, sharedActivitiesCount]
  );

  return (
    <div className={css.counters}>
      {countersData.map(({ title, tab, counter, displayRightSeparator }) => (
        <Counter
          key={tab}
          title={title}
          code={tab}
          counter={counter}
          selected={tab === currentTab}
          onClick={() => handleTabChange(tab)}
          classes={{ button: classNames(css.counter, { [css.rightSeparator]: displayRightSeparator }) }}
          disableIfZero={false}
        />
      ))}
      <Button
        kind="secondary"
        icon="admin"
        text={t("preferences")}
        onClick={handlePreferencesClick}
        className={css.preferencesButton}
      />
    </div>
  );
};
